import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import Loading from '../../common/Loading'

class servico extends Component {

    constructor(props){
        super(props);

        this.state = {
            items: [],
            filtros:[],
            itensRow:[],
            isListagem:true,
            isEdicao: false,
            id:'',
            codigo:'',
            nome:'',
            grupo:'',
            grupos:'',
            grupoDefault:'',
            cupom: '',
            permissao:'',
            precos:[],
            itemSelecionado:[],
            itemSelecionadoDefault:[],
            tipoSelecionado:[],
            tipoSelecionadoDefault:[],
            servico:null,
            tipo:null,
            preco:0,
            isValid: true,
            message: ''
            
        }

        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.cancel = this.cancel.bind(this);
        this.atualiza = this.atualiza.bind(this);
        this.precifica = this.precifica.bind(this);
        this.adicionar = this.adicionar.bind()
        this.excluir = this.excluir.bind()
        this.handleFiltroGrid = this.handleFiltroGrid.bind(this);

    }

    
    async Loading(isLoading) {
        this.setState({ isLoading: isLoading });
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');       
        this.Loading(true)
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaServico        = permissoes.data.filter(function(value){ return value.idmenu  == 16 })
        if(empresaServico.length > 0 && empresaServico[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 
        
        
        await api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => { 
            this.Loading(false)          
            this.setState( { items : response.data, filtros: response.data } );
        })
        this.Loading(false)
    }

    add = async(item) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaServico        = permissoes.data.filter(function(value){ return value.idmenu  == 16  })
        if(empresaServico.length > 0 && empresaServico[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
       
        const grupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        });

        let grupoServico = [];
        grupos.data.forEach(element => {
            grupoServico.push({value: element.id, label:element.nome })
        });
        
        this.setState({
            isListagem: false, 
            isEdicao:true,
            id:'',
            codigo: '',
            nome:'',  
            grupo:'',
            grupos: grupoServico,
            grupoDefault:[],
            precos:[],
            cupom: ''         
        })

    }

    edit = async( id ) => {
        
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');

        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaServico        = permissoes.data.filter(function(value){ return value.idmenu  == 16  })
        if(empresaServico.length > 0 && empresaServico[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
       
        const grupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        });

        let grupoServico = [];
        let grupoDefault = []
        try {
            await api.get(`/api/servico/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(response => {

                
                grupos.data.forEach(element => {
                    grupoServico.push({value: element.id, label:element.nome })
                    if(element.id == response.data.grupo) grupoDefault.push({value: element.id, label:element.nome })
                });

                this.setState({
                    isListagem: false, 
                    isEdicao:true,
                    id:response.data.id,
                    codigo: response.data.codigo,
                    nome:response.data.nome,
                    grupo:response.data.grupo,
                    grupos: grupoServico,
                    grupoDefault:grupoDefault ,
                    cupom: response.data.cupom             
                })      
            });

        } catch (error) {
            this.alert(error)       
        }
    }

    cancel = (item) => {
        const token    = sessionStorage.getItem('token');
       
        api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                codigo:'',
                nome:'',
                grupo:'',
                grupos: '',
                grupoDefault: '',
                cupom: '',
                items : response.data    
            })
        })     

    }

    save = async (event) => {
        event.preventDefault();
        const { id, codigo, nome, grupo, cupom } = this.state
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 16   })
      
        try {
            
            if ( id ) {
        
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
       
                await api.put(`/api/servico/${id}`,{ codigo, nome, grupo, cupom }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/servico', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            id:'',
                            codigo: '',
                            nome:'', 
                            grupo:'',
                            grupos:'',
                            grupoDefault:'', 
                            cupom: '',                       
                            items : response.data
                
                        });
                       
                    })
                })
            } else {
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
       
                await api.post('/api/servico',{ id, codigo, nome, grupo, cupom}, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then( async response => {
                    const grupo = response.data.id
                    
                    await api.get('/api/servico', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            id:'',
                            codigo:'',
                            nome:'',
                            grupo:'',
                            cupom: '',
                            grupos:'',
                            grupoDefault:'', 
                            items : response.data
                
                        });
                    })
                   
                })
            }
        } catch (error) {
            toast.error(error)            
        }
        
    }

    delete = async (id) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 16   })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( window.confirm(`Confirma deleção do registro ${id}?`)) {
            
                await api.delete(`/api/servico/${id}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/servico', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {
                        this.setState( { items : response.data } );
                        toast.error(<i class="fas fa-trash-alt nav-icon"> Registro Excluído Com Sucesso!</i>)
                    });
                });
            }
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar excluisr o registro.")       
        }
    }

    precifica = async( id ) => {
        const token    = sessionStorage.getItem('token');
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        
        this.Loading(true)
        
        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaPreco        = permissoes.data.filter(function(value){ return value.idmenu  == 17  })
        if(empresaPreco.length > 0 && empresaPreco[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 

        const tipo = []
        tipo.push({value: 0, label: 'Selecione Tipo'})
        tipo.push({value: 1, label: 'Lavar/Passar'})
        tipo.push({value: 2, label: 'Apenas Lavar'})
        tipo.push({value: 3, label: 'Apenas Passar'})

        const servicos = await api.get(`/api/servico/${id}`, {
            headers: {
                'x-access-token':token,
            }
        })

        const precos = await api.get(`/api/precificacao/item/${id}`, {
            headers: {
                'x-access-token':token,
            }
        })
        console.log(precos)
        this.Loading(false)      
        this.setState({ 
            itemSelecionado:[{
                value:servicos.data.id,
                label:servicos.data.nome
            }],
            itemSelecionadoDefault:[{
                value:servicos.data.id,
                label:servicos.data.nome
            }],
            precos: precos.data,
            tipoSelecionado : tipo, tipoSelecionadoDefault: tipo[0],
            servico: id,
            tipo:null,
            preco:0,
            isValid: true,
            message: ""     
        })      
    
      
    }
    
    adicionar = async() => {

        const token    = sessionStorage.getItem('token');
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        
        this.Loading(true)
        
        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaPreco        = permissoes.data.filter(function(value){ return value.idmenu  == 17  })
        if(empresaPreco.length > 0 && empresaPreco[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário não tem permissão de adicionar preço.')

        const servico = this.state.servico
        const tipo    = this.state.tipo
        const preco   = this.state.preco    
        
        if(!servico || !tipo || ( preco == 0 || !preco ) ) {
            this.Loading(false)
            this.setState({
                isValid: false,
                message: "Os campos serviço, tipo e preço são obrigatórios."
            })

        } else {
            this.setState({
                isValid: true,
                message: ""
            })

        }

        const tipoValido = await api.get(`/api/precificacao/item/${servico}`, {
            headers: {
                'x-access-token':token,
            }
        })
        
        const isExistType        = tipoValido.data.filter(function(value){ return value.tipo  == tipo  });

        if(!isExistType.length) {

            await api.post('/api/precificacao', { servico, tipo, preco }, {
                headers: {
                    'x-access-token':token,
                }
            });             
             
        } else {

            await api.put(`/api/precificacao/${isExistType[0].id}`, { servico, tipo, preco }, {
                headers: {
                    'x-access-token':token,
                }
            }); 
        }

        const precos = await api.get(`/api/precificacao/item/${servico}`, {
            headers: {
                'x-access-token':token,
            }
        })


        this.Loading(false)      
        this.setState({ 
            itemSelecionado:[this.state.itemSelecionado[0]],
            itemSelecionadoDefault:[this.state.itemSelecionado[0]],
            precos: precos.data,
            tipoSelecionadoDefault: this.state.tipoSelecionado[0],
            preco:0              
        })   



    }

    excluir = async( id ) => {
        const token    = sessionStorage.getItem('token');
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        
        this.Loading(true)
     
        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaPreco        = permissoes.data.filter(function(value){ return value.idmenu  == 17  })
        if(empresaPreco.length > 0 && empresaPreco[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário não tem permissão de excluir preço.')
        
        const item = await api.get(`/api/precificacao/${id}`, {
            headers: {
                'x-access-token':token,
            }
        })

        await api.delete(`/api/precificacao/${item.data[0].id}`, {
            headers: {
                'x-access-token':token,
            }
        })

        const precos = await api.get(`/api/precificacao/item/${item.data[0].servico}`, {
            headers: {
                'x-access-token':token,
            }
        })

        this.Loading(false)      
        this.setState({ 
            itemSelecionado:[this.state.itemSelecionado[0]],
            itemSelecionadoDefault:[this.state.itemSelecionado[0]],
            precos: precos.data,
            tipoSelecionadoDefault: this.state.tipoSelecionado[0],
            preco:0              
        })  
    }
    
    atualiza = async() => {

        const token    = sessionStorage.getItem('token');
       
        await api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                codigo:'',
                nome:'',               
                items : response.data    
            })
        })
    }


    handleFiltroGrid = async (filterText) => {
        const { filtros, items } = this.state;
        this.Loading(true);
        const filtragem =
          filterText.length > 0
            ? items.filter((item) =>
                (
                  item.id +
                  "" +
                  item.nome + 
                  "" +
                  item.codigo +
                  "" +
                  item.grupo
                )
                  .toLowerCase()
                  .includes(filterText.toLowerCase())
              )
            : filtros;
        this.setState({ items: filtragem, filterText: filterText });
    
        this.Loading(false);
    };
    
    render() {
        const subHeaderComponentMemo = (
            <div class="card-tools">
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar"
                  onChange={(e) => this.handleFiltroGrid(e.target.value)}
                />
                <div class="input-group-append">
                  <div class="btn btn-primary">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
              </div>
            </div>
          );

        const columns = [
            {
                name: 'Codigo',
                selector: 'codigo',
                sortable: true,
            },
            {
              name: 'Nome',
              selector: 'nome',
              sortable: true,
            }, 
            {
                name: 'Grupo',
                selector: 'grupo',
                sortable: true,
            }, 
            {
                name: 'Cupom?',
                selector: 'cupom',
                sortable: true,
                cell: row => row.cupom ? 'SIM' : 'NÃO'
            },  
            {
                name: 'Preço',
                selector: 'preco',
                sortable: true,
                cell: row =>   <div class="btn-group">
                                  <button id="editar" className="btn btn-warning" data-toggle="modal" data-target="#modal-xl" onClick={ () => { this.precifica( row.id )}}>$</button>
                              </div>,
                button: true,
            },           
            {
                name: 'Editar',
                selector: 'Editar',
                cell: row =>   <div class="btn-group">
                                  <button id="editar" className="btn btn-default" onClick={ () => { this.edit(row.id)}}><i class="fa fa-edit"></i></button>
                                  <button id="excluir" className="btn btn-danger" onClick={ () => { this.delete(row.id)}}><i class="fas fa-trash-alt"></i></button>                                                           
                              </div>,
                button: true,
            }
        ];

        
        const {items,isListagem, isEdicao} = this.state;
    
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> CADASTRO SERVIÇOS</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => this.atualiza() }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                        
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ isListagem ? "nav-link active" : "nav-link" } id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => this.cancel } href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ isListagem ? true : false }>Listagem</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ isEdicao   ? 'nav-link active' : 'nav-link' } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() => this.add } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={isEdicao ? true : false }>Edição</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={ isListagem ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-listagem-dados" role="tabpanel" aria-labelledby="custom-tabs-listagem-dados-tab">
                                                <DataTable
                                                    title="Listar"
                                                    columns={columns}
                                                    data={items}
                                                    pagination
                                                    subHeader
                                                    subHeaderComponent={subHeaderComponentMemo}
                                                />
                                                <button type="button" onClick={ this.add } className="btn btn-info pull-right">Novo</button>
                                               
                                            </div>
                                            <div class="modal fade" id="modal-xl">
                                                <div class="modal-dialog modal-xl">
                                                    <div class="modal-content">
                                                        {  this.state.isLoading ?
                                                            <div class="overlay">
                                                                <i class="fas fa-2x fa-sync fa-spin"></i>
                                                            </div> :
                                                            ''
                                                        }
                                                        <div class="modal-header">
                                                            <h4 class="modal-title">Precificação de Serviços</h4>
                                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            <div class="row">
                                                                <div class="col-sm-3">
                                                                    <label>Serviço</label>
                                                                    <Select
                                                                    id="itemSelecionado"
                                                                    placeholder="Selecione"
                                                                    isDisabled="true"
                                                                    options={this.state.itemSelecionado}
                                                                    value={this.state.itemSelecionadoDefault[0]}
                                                                    onChange={ e => { this.setState({ servico: e.value })}}
                                                                    />
                                                                </div>
                                                                <div class="col-sm-3">
                                                                    <label>Tipo</label>
                                                                    <Select
                                                                    id="tipo"
                                                                    placeholder="Selecione"
                                                                    options={this.state.tipoSelecionado}
                                                                    value={this.state.tipoSelecionadoDefault}
                                                                    onChange={ e => this.setState({ tipoSelecionadoDefault: e, tipo: e.value })}
                                                        
                                                                    
                                                                    />
                                                                </div>
                                                                
                                                                <div class="col-sm-3">
                                                                    <div class="form-group">
                                                                        <label>Preço</label>
                                                                        <CurrencyInput
                                                                            id="preco"
                                                                            name="input-preco"
                                                                            className="form-control" 
                                                                            placeholder="Informe o valor do serviço"
                                                                            defaultValue={ 1.00 }
                                                                            decimalsLimit={2}
                                                                            value={this.state.preco ? this.state.preco : 0.00 }
                                                                            onValueChange={(value, name) => this.setState({ preco: value })}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-3">
                                                                    <label>&nbsp;&nbsp;</label>
                                                                    <button type="button" class="btn btn-block btn-outline-success" onClick={ () => { this.adicionar()} }>Adicionar</button>
                                                                </div>
                                                            </div>
                                                            {
                                                                !this.state.isValid ?
                                                                <div class="alert alert-danger alert-dismissible">
                                                                    <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                                                                    { this.state.message }
                                                                </div> : ''
                                                            }
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                <table class="table table-sm">
                                                                    <thead>
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>Tipo</th>
                                                                        <th>Valor</th>
                                                                        <th></th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {
                                                                    
                                                                        this.state.precos.map((item, i) => (
                                                                            <tr key={i}>
                                                                                <td>{i + 1}.</td>
                                                                                <td>{item.tipo == 1 ? 'Lavar e Passar' : item.tipo == 2 ? 'Lavar' : 'Passar'}</td>
                                                                                <td>
                                                                                    {
                                                                                        item.preco ? Number(item.preco).toFixed(2) : "0.00"
                                                                                    }
                                                                                </td>
                                                                                <td>
                                                                                    <button  id="excluir" className="btn btn-tool" onClick={() => { this.excluir(item.id)}}>
                                                                                        <i class="fas fa-trash-alt"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                   
                                                                    </tbody>
                                                                </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="modal-footer justify-content-between">
                                                            <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className={ isEdicao ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <form onSubmit={ this.save }>
                                                    <div className="form-group">
                                                        <label>ID</label>
                                                        <input type="text" className="form-control" name="id" placeholder="ID do Registro" value={ this.state.id } onChange={ e => this.setState({ id: e.target.value})} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Código</label>
                                                        <input type="text" className="form-control" name="codigo" placeholder="Codigo do Registro" value={ this.state.codigo } onChange={ e => this.setState({ codigo: e.target.value})} required/>
                                                    </div>
                                                    
                                                    <div className="form-group">
                                                        <label>Nome</label>
                                                        <input type="text" className="form-control" name="nome" placeholder="Nome do Registro" value={ this.state.nome } onChange={ e => this.setState({ nome: e.target.value})} required/>
                                                    </div>

                                                    <div class="form-group">
                                                        <label>Grupo</label>
                                                        <Select
                                                            id="grupo"
                                                            placeholder="Selecione" 
                                                            isSearchable="true"
                                                            isOptionSelected
                                                            value={this.state.grupoDefault}
                                                            options={ this.state.grupos } 
                                                            onChange={ e => this.setState({grupo: e.value, grupoDefault:[{label: e.label, value: e.value }] })}
                                                        />
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="form-check">
                                                            <input 
                                                                id="cupom" 
                                                                name="cupom" 
                                                                type="checkbox" 
                                                                class="form-check-input" 
                                                                checked={ this.state.cupom }
                                                                value={ this.state.cupom  }
                                                                onClick={ e => this.state.cupom ? this.setState({cupom: false }) : this.setState({cupom: true })}
                                                            />
                                                            <label class="form-check-label" for="exampleCheck1">É Serviço no cupom?</label>
                                                        </div>
                                                    </div>
                                                    
                                                    <button type="submit" className="btn btn-success pull-right">Salvar</button>
                                                    <button type="button" className="btn btn-danger pull-right" onClick={ this.cancel }>Cancelar</button>
                                                </form>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="card-footer">                        
                            </div>
                            <Loading isCarrega={ this.state.isLoading } />
                        </div>
                    </section>
                </div>
            </div>
        )
    }
        
}

export default servico;